import HeroCarousel from "./components/HeroCarousel";
import SearchBand from "./components/SearchBand";
import CategoryEntry from "./components/CategoryEntry";
import RecommendTabs from "./components/RecommendTabs";
import SpecialStrip from "./components/SpecialStrip";
import SiteIntro from "./components/SiteIntro";
import { usePageSeo } from "@/hooks/usePageSeo";

export default function Home() {
  usePageSeo({
    title: "91av视频 - 综合影视视频资源在线观看平台",
    description:
      "91av视频提供丰富多样的影视视频内容，涵盖电影、电视剧、综艺等多种类型，方便用户在线观看和浏览最新影视资源。",
    keywords: "91av视频,影视视频,在线视频,电影电视剧,影视资源,高清视频,视频播放",
  });

  return (
    <>
      <HeroCarousel />
      <SearchBand />
      <CategoryEntry />
      <RecommendTabs />
      <SpecialStrip />
      <SiteIntro />
    </>
  );
}